export const COOKIE_CONSENT_VALUE = "1";

export const COOKIES_ACCEPT = "cookies_accept";
